import React, { useState, useEffect } from "react";
import styled from "styled-components";

const PercentageLabel = ({
  toDisplay,
  question,
  answeredQuestions,
  setAnsweredQuestions,
  setCurrentPageAnswers,
  currentPage,
  parseDynamicQuestionText
}) => {
  const [inputValues, setInputValues] = useState(
    [
      ...question.Answers,
      question.Answers.find((obj) => obj.AnswerType === "Other"),
    ].map((obj) => ({
      normal: obj.AnswerType === "Normal" ? "0" : null,
      otherText: obj.AnswerType === "Other" ? "-998" : null,
      otherRank: obj.AnswerType === "Other" ? "0" : null,
    }))
  );

  useEffect(() => {
          
    if (toDisplay && answeredQuestions[currentPage - 1]?.length) {
                          
      let otherValue = answeredQuestions[currentPage - 1]?.find((ans) =>
        ans?.includes("_o")
      );
          
      setInputValues(
        [
          ...answeredQuestions[currentPage - 1]
            .filter(
              (answer) =>
                answer.split("_")[0] ===
                question.Answers[0].AnswerCode.split("_")[0]
            )
            .map((ans) => ({
              normal: ans.includes("_o")
                ? null
                : otherValue && ans.includes(otherValue.split("_o")[0])
                ? null
                : ans.split("=")[1] === "0" || ans.split("=")[1] === "null"
                ? "0"
                : ans.split("=")[1],
              otherText: ans.includes("_o")
                ? ans.split("=")[1] === "0" || ans.split("=")[1] === "" || ans.split("=")[1] === "null"
                  ? "-998"
                  : ans.split("=")[1]
                : null,
              otherRank:
                !ans.includes("_o") &&
                otherValue &&
                ans.includes(otherValue.split("_o")[0])
                  ? ans.split("=")[1] === "0" || ans.split("=")[1] === "null"
                    ? "0"
                    : ans.split("=")[1]
                  : null,
            })),
          !otherValue && {
            normal: null,
            otherText: "",
            otherRank: null,
          },
        ].filter((val) => val)
      );

      if (!otherValue) {
        let answeredQuestionsCopy = [...answeredQuestions];

        //for other description
        answeredQuestionsCopy[currentPage - 1] = answeredQuestionsCopy[currentPage - 1].map(
          val => val.includes(question.Answers[question.Answers.findIndex(answerObj => answerObj.AnswerType === 'Stay')].AnswerCode) ? `${val.split('=')[0]}=0` : val)
          
        answeredQuestionsCopy[currentPage - 1]?.push(
          `${
            question.Answers.find((answer) => answer.AnswerType === "Other")
              .AnswerCode
          }_o=-998`
        );
           
               
        setAnsweredQuestions(answeredQuestionsCopy);

        setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1]);
      } else {
        let answeredQuestionsCopy = [...answeredQuestions]
        answeredQuestionsCopy[currentPage - 1] = answeredQuestionsCopy[currentPage - 1].map(val => val.includes(question.Answers[question.Answers.findIndex(answerObj => answerObj.AnswerType === 'Stay')].AnswerCode) ? `${val.split('=')[0]}=0` : val)
         
        setAnsweredQuestions(answeredQuestionsCopy)
      }
    }
  }, [toDisplay]);


  useEffect(() => {
    let currentPageAnswers = answeredQuestions[currentPage - 1];
    if (!currentPageAnswers.length) {
      let answeredQuestionsCopy = [...answeredQuestions];
      answeredQuestionsCopy[currentPage - 1] = question.Answers.map(
        (questionObject) => `${questionObject.AnswerCode}=0`
      );

      //for other description
      answeredQuestionsCopy[currentPage - 1]?.push(
        `${
          question.Answers.find((answer) => answer.AnswerType === "Other")
            .AnswerCode
        }_o=-998`
      );

      setAnsweredQuestions(answeredQuestionsCopy);
             
      setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1]);
    } 
  }, []);

  useEffect(() => {
    let currentPageAnswers = answeredQuestions[currentPage - 1];
       
    if (!currentPageAnswers.length) {
         
      let answeredQuestionsCopy = [...answeredQuestions];

      answeredQuestionsCopy[currentPage - 1] = question.Answers.map(answer => `${answer.Expression.split('=')[0]}=0`)

      answeredQuestionsCopy[currentPage - 1]?.push(
        `${
          question.Answers.find((answer) => answer.AnswerType === "Other")
            .AnswerCode
        }_o=-998`
      );

      setAnsweredQuestions(answeredQuestionsCopy);
      setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1]);
    } else {
      let answeredQuestionsCopy = [...answeredQuestions];

      answeredQuestionsCopy[currentPage - 1] = currentPageAnswers.map(answer => answer.includes('_o') ? answer.split('=')[1] === 'null' ? `${answer.split('=')[0]}=-998` : answer : answer.split('=')[1] === 'null' ? `${answer.split('=')[0]}=0` : answer)

             
      setAnsweredQuestions(answeredQuestionsCopy);
      setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1]);
    }

  }, [currentPage])

  const calculateTotal = () => {
                               
    const normalValues = inputValues
      .filter((val, i) => i !== question.Answers.findIndex(answerObj => answerObj.AnswerType === 'Stay'))
      .map((item) => item.normal)
      .filter((value) => value !== "")
      .map(Number);

    const otherRankValues = inputValues
      .map((item) => item.otherRank)
      .filter((value) => value !== "")
      .map(Number);
     
    const total = normalValues
      .concat(otherRankValues)
      .reduce((acc, value) => acc + value, 0);
    return total;
  };

  const handleInputChange = (index, value, field) => {
          
    if (
      (field === "normal" || field === "otherRank") &&
      !/^([0-9]|[1-9][0-9]|100)?$/.test(value)
    ) {
      return;
    }

    const updatedValues = [...inputValues];
    updatedValues[index][field] = value;
    setInputValues(updatedValues);

    let answeredQuestionsCopy = [...answeredQuestions];

    if (field === "otherText") {
            
      let index = answeredQuestionsCopy[currentPage - 1]?.indexOf(
        answeredQuestionsCopy[currentPage - 1]?.find((answerCode) =>
          answerCode?.includes("_o")
        )
      );

      if (index === -1) {
        index = inputValues.length - 1 
        
        answeredQuestionsCopy[currentPage - 1][index] = `${question.Answers.find((questionObj) =>
          (questionObj.AnswerType === 'Other' || questionObj.AnswerType === 'Email' || questionObj.AnswerType === 'Numeric' || questionObj.AnswerType === 'FloatingPoint')
        ).Expression.split('=')[0]}_o=`
      }
            

      const updatedValues = [...inputValues];
      updatedValues[index].otherText = value !== "" && value !== "null" ? value : "-998";

      setInputValues(updatedValues);

      answeredQuestionsCopy[currentPage - 1][index] = answeredQuestionsCopy[currentPage - 1][index] ? `${
        answeredQuestionsCopy[currentPage - 1][index].split("=")[0]
      }=${value !== "" && value !== "null" ? value : "-998"}` : `${question.Answers[index].Expression.split('=')[0]}_o=${value !== "" && value !== "null" ? value : "-998"}`;
    } else {
                                 
      answeredQuestionsCopy[currentPage - 1][index] = question.Answers[
        index
      ].Expression.replace("_o", "").replace(
        "$Input$",
        value !== "" ? value : "0"
      );

      if (question.Answers[index].AnswerType === "Stay") {
        answeredQuestionsCopy[currentPage - 1][index] = question.Answers[
          index
        ].Expression.replace("$Input$", calculateTotal());
      }
    }
           
    setAnsweredQuestions(answeredQuestionsCopy);
    setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1]);
  };

  useEffect(() => {
           
    if (inputValues.map(value => value.normal || value.otherRank).filter(val => val && val !== '' && val !== '0').length) {
      const total = calculateTotal();
      const stayIndex = question.Answers.findIndex(
        (obj) => obj.AnswerType === "Stay"
      );

      let answeredQuestionsCopy = [...answeredQuestions];
      if (stayIndex !== -1) {
        answeredQuestionsCopy[currentPage - 1][stayIndex] = question.Answers[
          stayIndex
        ].Expression.replace("$Input$", total);
               
        setAnsweredQuestions(answeredQuestionsCopy);
        setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1]);
      }
    }
  }, [inputValues]);

    

  return (
    <>
      <StyledH2
        dangerouslySetInnerHTML={{ __html: parseDynamicQuestionText(question.QuestionName, true) }}
      ></StyledH2>
      {question.Answers.map((obj, index) => {
        if (obj.AnswerType === "Normal") {
          return (
            <Container key={index}>
              <label dangerouslySetInnerHTML={{ __html: obj.AnswerLabel }} />
              <InputContainer>
                <Input
                  type="text"
                  maxLength={3}
                  placeholder="Please type a value from 0 to 100"
                  value={inputValues[index]?.normal === "0" ? null : inputValues[index]?.normal}
                  onChange={(e) =>
                    handleInputChange(index, e.target.value, "normal")
                  }
                />
                <PercentageSymbol>%</PercentageSymbol>
              </InputContainer>
            </Container>
          );
        }

        if (obj.AnswerType === "Other") {
          return (
            <Container key={index}>
              <Input
                type="text"
                placeholder={obj.AnswerLabel}
                value={
                  inputValues[inputValues.findIndex((obj) => obj.otherText)]
                    ?.otherText !== "-998" ? inputValues[inputValues.findIndex((obj) => obj.otherText)]
                    ?.otherText : ""
                }
                onChange={(e) =>
                  handleInputChange(index, e.target.value, "otherText")
                }
              />
              <InputContainer>
                <Input
                  type="text"
                  maxLength={3}
                  placeholder="Please type a value from 0 to 100"
                  value={inputValues[index]?.otherRank === "0" ? null : inputValues[index]?.otherRank}
                  onChange={(e) =>
                    handleInputChange(index, e.target.value, "otherRank")
                  }
                />
                <PercentageSymbol>%</PercentageSymbol>
              </InputContainer>
            </Container>
          );
        }

        if (obj.AnswerType === "Stay") {
          return (
            <Container key={index}>
              <div>
                <span>Total:</span>
              </div>
              <InputContainer>
                <Input
                  type="text"
                  maxLength={3}
                  disabled={true}
                  value={calculateTotal()}
                  onChange={(e) =>
                    handleInputChange(index, e.target.value, "otherRank")
                  }
                />
                <PercentageSymbol>%</PercentageSymbol>
              </InputContainer>
            </Container>
          );
        }

        return null;
      })}
    </>
  );
};

const Container = styled.div`
  display: flex;
  width: 820px;
  justify-content: space-between;
  margin-bottom: 20px;

  span,
  label {
    @media (max-width: 765px) {
      margin-left: 10px;
    }
  }

  @media (max-width: 765px) {
    flex-direction: column;
  }
`;

const StyledH2 = styled.h2`
  width: 870px;

  @media (max-width: 765px) {
    font-size: 18px;
    width: auto;
    margin-left: 10px;
  }  
`

const Input = styled.input`
  width: 383px;
  height: 43px;
  font-size: 16px;
  padding-left: 10px;
  border-radius: 5px;
  border: 2px solid transparent;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px,
    rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;

  ::placeholder {
    color: #cad4e1 !important;
  }

  &:hover {
    border: 2px solid #5bc5cd;
    color: #5bc5cd;
  }

  &:focus {
    border: 2px solid #5bc5cd;
    outline: none;
  }

  &:disabled {
    border: 2px solid gray;
    opacity: 0.5;
  }

  @media (max-width: 765px) {
    width: 90vw;
    margin-left: 10px;
    margin-top: 10px;
  }

  @media (max-width: 545px) {
    margin-left: 5px;
  }
`;

const InputContainer = styled.div`
  position: relative;
`;

const PercentageSymbol = styled.span`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 21px;
  color: #5bc5cd;

  ${Input}:hover + & {
    font-weight: 700;
    color: #5bc5cd;
  }
`;

export default PercentageLabel;
